import { render, staticRenderFns } from "./PlansDeveloppement.vue?vue&type=template&id=82564cf2&"
import script from "./PlansDeveloppement.vue?vue&type=script&lang=ts&"
export * from "./PlansDeveloppement.vue?vue&type=script&lang=ts&"
import style0 from "./PlansDeveloppement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports